console.log('product-quiz.js');

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }


  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    //history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if(event.target.id !== 'searchFragrance'){
      //console.log('this',event.target);
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      if (event.srcElement.className == 'mobile-facets__checkbox') {
        const searchParams = this.createSearchParams(event.target.closest('form'));
        this.onSubmitForm(searchParams, event);
      } else {
        const forms = [];
        const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
  
        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
              const noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach((el) => el.remove());
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join('&'), event);
      }
    }    
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);






window.addEventListener("load", function (event) {
  // .button-next
  $('#find-your-fragrance .stepsWrap .steps.active').change(function (e) {
     console.log('this that');
    if(document.querySelectorAll('#find-your-fragrance .stepsWrap .steps.active input:checked').length == 0){
      $('#find-your-fragrance .step-btnsWrap .button.button-next').prop('disabled', true);
    } else {
      $('#find-your-fragrance .step-btnsWrap .button.button-next').prop('disabled', false);
    }

  });
  $('#find-your-fragrance .step-btnsWrap .button').click(function (e) {
      var thisEl = $(".stepsWrap .steps.active");
      if (!$(this).hasClass('button-back')) {
          console.log('next');
          // $('#find-your-fragrance .step-btnsWrap .button.button-next').prop('disabled', true);
          if ($(".stepsWrap .steps.active").is(':first-child')) {
              $('#find-your-fragrance .step-btnsWrap .button.button-back').removeClass('hidden');
          }
          var nextEl = $(".stepsWrap .steps.active").next();
          $(".stepsWrap .steps.active").removeClass('active')
          nextEl.addClass('active');

          console.log(thisEl.attr('id'));
          if(thisEl.attr('id') === 'step-5'){
              $('#find-your-fragrance .step-btnsWrap').hide();
              $('#find-your-fragrance .step-dots').hide();
              $('#ProductGridContainer').addClass('active');
              console.log($('#ProductGridContainer'));
              $('.showingResults').show();
              $(this).addClass('hidden');
          }
          
          $("#find-your-fragrance .step-dots li.active").removeClass('active').next().addClass('active');
          /* 
          $('#find-your-fragrance .stepsWrap .steps.active').change(function (e) {
            console.log('this');
            if(document.querySelectorAll('#find-your-fragrance .stepsWrap .steps.active input:checked').length == 0){
              $('#find-your-fragrance .step-btnsWrap .button.button-next').prop('disabled', true);
            } else {
              $('#find-your-fragrance .step-btnsWrap .button.button-next').prop('disabled', false);
            }
        
          });
           */

      } else {
          console.log('back');
          if ($(".stepsWrap .steps.active").is(':last-child')) {
              $('#find-your-fragrance .step-btnsWrap .button.button-next').removeClass('hidden')
          }
          var prevEl = $(".stepsWrap .steps.active").prev();
          console.log(prevEl);
          $(".stepsWrap .steps.active").removeClass('active');
          prevEl.addClass('active');


          if (prevEl.is(':first-child')) {
              $(this).addClass('hidden');
          }
          $("#find-your-fragrance .step-dots li.active").removeClass('active').prev().addClass('active');

      }
  });
  
document.querySelector('.searchFragranceBtn').addEventListener('click', checkSearchValue);
function checkSearchValue() {
    console.log('s click');
    var searchValue = document.getElementById('searchFragrance').value;
    if (searchValue === '') {
        $('#find-your-fragrance .step-btnsWrap button.button.button-next').prop("disabled", true);   
        //console.log('s this');
    } else {
        var productGridEl = document.querySelector('#find-your-fragrance .product-grid');
        productGridEl.innerHTML = null;
        $('.pagination-wrapper').remove();
        $('#find-your-fragrance .step-btnsWrap button.button.button-next').prop("disabled", false);   
        var sectionid = document.getElementById('searchFragrance').closest(".facets-wrapper").dataset.id;
        //console.log('this',sectionid, searchValue);
        fetch(`/search/suggest.json?resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=tag&q=${searchValue}`)
          .then((response) => response.json())
          .then((data) => {
            if(data.resources.results.products.length > 0){
              console.log(data.resources.results.products.length);
               $.ajax({
                 url: `/search?type=product&options%5Bprefix%5D=last&q=${searchValue}`,
                //url: `/collections/all/${searchValue}`,
                type: 'GET',
                success: function(responseText) {
                    //console.log(responseText);
                    var responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                    var newHTML = $(responseHTML).find('#ProductGridContainer ul').html()
                    console.log(newHTML);
                    $(productGridEl).html(newHTML);        
                    $(".stepsWrap .steps#step-1").removeClass('active');
                    $('#find-your-fragrance .step-btnsWrap').hide();
                    $('#find-your-fragrance .step-dots').hide();
                    $('#ProductGridContainer').addClass('active');
                    $('.showingResults').show();
                    $('.showingResults .active-facets').html(`<b>Showing results for:</b> &nbsp;${searchValue}`);
                }
              }); 
            } else {
                  $(".stepsWrap .steps#step-1").removeClass('active');
                  $('#find-your-fragrance .step-btnsWrap').hide();
                  $('#find-your-fragrance .step-dots').hide();
                  $('#ProductGridContainer').addClass('active');
                  $('.showingResults').show();
                  $('.showingResults .active-facets').html(`<b>Showing results for:</b> &nbsp;${searchValue}.<small>Check the spelling or use a different word or phrase.<small>`);
              //products found for
            }
          })
          .catch(console.error);
    }
}
//checkSearchValue();

    $("#searchFragrance").on("keypress", function (event) { 
      console.log("aaya"); 
      var keyPressed = event.keyCode || event.which; 
      if (keyPressed === 13) { 
          checkSearchValue();
          event.preventDefault(); 
          return false; 
      } 
  }); 
});